/**
 * Обёртка над console для разработки.
 *
 * До этого в коде было 273 прямых вызова console.*, и все они уезжали
 * в продакшен-сборку: пользователь видел в консоли стектрейсы и русские
 * тексты внутренних ошибок.
 *
 * Здесь вывод включён только в разработке. Когда появится сервис сбора
 * ошибок (Sentry и подобные), точка подключения — метод `error` ниже:
 * менять придётся один файл, а не 62.
 */

// Проверяем на момент вызова, а не при импорте: так поведение можно
// проверить тестом, а стоимость обращения к process.env ничтожна.
const isDevelopment = (): boolean => process.env.NODE_ENV !== "production";

type LogArgs = unknown[];

export const logger = {
  debug: (...args: LogArgs): void => {
    if (isDevelopment()) {
      console.debug(...args);
    }
  },

  log: (...args: LogArgs): void => {
    if (isDevelopment()) {
      console.log(...args);
    }
  },

  info: (...args: LogArgs): void => {
    if (isDevelopment()) {
      console.info(...args);
    }
  },

  warn: (...args: LogArgs): void => {
    if (isDevelopment()) {
      console.warn(...args);
    }
  },

  error: (...args: LogArgs): void => {
    if (isDevelopment()) {
      console.error(...args);
    }
    // TODO: здесь подключается внешний сбор ошибок для продакшена.
  },
};

export default logger;
